// src/utils/country.js

let sharedDisplayNames = null;

function getDisplayNames(locales) {
  if (sharedDisplayNames) return sharedDisplayNames;
  try {
    const langs = [];
    if (Array.isArray(locales) && locales.length) langs.push(...locales);
    if (typeof navigator !== 'undefined' && navigator.language) langs.push(navigator.language);
    langs.push('de-DE', 'en');
    sharedDisplayNames = new Intl.DisplayNames(langs, { type: 'region' });
  } catch {
    sharedDisplayNames = null;
  }
  return sharedDisplayNames;
}

export function normalizeISO2(raw) {
  if (!raw) return null;
  const code = String(raw).trim().toUpperCase().replace(/[^A-Z]/g, '').slice(0, 2);
  return /^[A-Z]{2}$/.test(code) ? code : null;
}

export function flagFromISO2(code) {
  const c = normalizeISO2(code);
  if (!c) return null;
  const A = 0x1F1E6; // regional indicator base
  const points = c.split('').map(ch => A + (ch.charCodeAt(0) - 65));
  return String.fromCodePoint(...points);
}

export function flagSvgUrl(code) {
  const c = normalizeISO2(code);
  if (!c) return null;
  return `/assets/flags/svg/${c.toLowerCase()}.svg`;
}

export function regionNameFromISO2(code, locales) {
  const c = normalizeISO2(code);
  if (!c) return null;
  const dn = getDisplayNames(locales);
  if (!dn) return c;
  try { return dn.of(c) || c; } catch { return c; }
}

/** Details-Array -> Map by setting_name (lowercased) */
export function detailsToMap(details) {
  const map = {};
  (details || []).forEach(d => {
    const k = String(d?.setting_name || '').trim().toLowerCase();
    if (k) map[k] = d;
  });
  return map;
}

/** Country-Objekt aus Details ermitteln (robust, inkl. Fallback auf setting_id === 10) */
export function countryFromDetails(details, locales) {
  const dmap = detailsToMap(details);
  let code = normalizeISO2(dmap['country_code']?.value ?? dmap['country']?.value);

  if (!code) {
    const byId = (details || []).find(x => x?.setting_id === 10 && x?.value);
    code = normalizeISO2(byId?.value);
  }
  if (!code) return null;

  return {
    code,
    flag: flagFromISO2(code),
    svgUrl: flagSvgUrl(code),
    name: regionNameFromISO2(code, locales) || code
  };
}